import { Anchor, AnchorExtendedProps, Box, Main, Text } from 'grommet';
import TalonLogo from 'jsx:@talon/web/public/images/talon-ai-logo.svg';
import { ReactNode } from 'react';

export type AuthCardProps = {
  title: string;
  /** A small line above the title, like "Step 1 of 2" */
  caption?: string;
  /** Sign-up forms are wider */
  wide?: boolean;
  /** Links to the other auth pages, under a divider */
  footer?: ReactNode;
  children: ReactNode;
};

/** The card that log in, sign up, password reset and the other signed-out pages sit in */
export const AuthCard = ({ title, caption, wide, footer, children }: AuthCardProps) => (
  <Main background="surface-header" pad="large" justify="center" align="center" fill="vertical">
    <Box
      background="white"
      border={{ color: 'border-card' }}
      round="12px"
      pad="28px"
      gap="14px"
      width={{ width: wide ? '480px' : '384px', max: '100%' }}
      flex={false}
    >
      <Box direction="row" align="center" gap="10px">
        <TalonLogo width="40" height="40" />
        <Box>
          {caption && (
            <Text size="12px" color="text-label">
              {caption}
            </Text>
          )}
          <Text as="h1" size="22px" weight={600} color="text-heading" margin="none">
            {title}
          </Text>
        </Box>
      </Box>
      {children}
      {footer && (
        <Box
          direction="row"
          justify="between"
          wrap
          gap="small"
          border={{ side: 'top', color: 'border-divider' }}
          pad={{ top: '12px' }}
        >
          {footer}
        </Box>
      )}
    </Box>
  </Main>
);

/** A link in an auth card */
export const AuthLink = (props: AnchorExtendedProps) => <Anchor size="14px" weight={600} color="brand" {...props} />;
